import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login.component';
import { RegisterComponent } from './register.component';

import { AuthService } from './auth.service';
@NgModule({
    imports: [FormsModule, CommonModule, ReactiveFormsModule, AuthRoutingModule],
    declarations: [LoginComponent, RegisterComponent],
    exports: [],
    providers: [AuthService]
})
export class AuthModule { }

